import { PayloadAction } from '@reduxjs/toolkit';
import { SnapSuggestionStatus } from '@snap-types/models/common';
import { weeksToDays } from 'date-fns';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { validateLeadTime } from '../validations/lead-time';
import { QuoteLineParams } from './types';

interface Params extends QuoteLineParams {
  leadTimeInWeeks: string;
}

export function leadTimeChanged(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const { quoteLineUuid, leadTimeInWeeks } = action.payload;
  const newLeadTime = validateLeadTime(state, {
    leadTime: leadTimeInWeeks,
    quoteLineUuid,
  });

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  quoteLine.leadTime = weeksToDays(newLeadTime ?? 0);

  const { leadTime, automatedLeadTime } = quoteLine;

  quoteLine.leadTimeSuggestionStatus =
    leadTime === automatedLeadTime
      ? SnapSuggestionStatus.ACCEPTED
      : SnapSuggestionStatus.REJECTED;

  if (quoteLine.leadTimeSuggestionStatus !== SnapSuggestionStatus.ACCEPTED) {
    quoteLine.automatable = false;
  }
}
